(function () {
  'use strict';

  function route(base) {
    var params = {
      jp_view: null,
      mode: null,
      panel: null,
      item: null,
      design: null,
      return_to: null
    };
    if (window.JPRuntime && typeof window.JPRuntime.route === 'function') return window.JPRuntime.route(base, params);
    try {
      var url = new URL(String(base || (window.jpRoutes && window.jpRoutes.customizer) || '/products/custom-temporary-tattoos'), window.location.origin);
      Object.keys(params).forEach(function (key) { url.searchParams.delete(key); });
      return url.origin === window.location.origin ? url.pathname + url.search + url.hash : url.toString();
    } catch (_) {
      return String(base || '/products/custom-temporary-tattoos');
    }
  }

  function refresh(scope) {
    (scope || document).querySelectorAll('[data-jp-start-route]').forEach(function (control) {
      var base = control.dataset.jpStartBase || control.getAttribute('href') || (window.jpRoutes && window.jpRoutes.customizer) || '/products/custom-temporary-tattoos';
      control.dataset.jpStartBase = base;
      if (control.tagName === 'A') control.setAttribute('href', route(base));
    });
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-jp-start-route]');
    if (!control) return;
    var base = control.dataset.jpStartBase || control.getAttribute('href') || (window.jpRoutes && window.jpRoutes.customizer) || '/products/custom-temporary-tattoos';
    var destination = route(base);
    if (control.tagName === 'A') {
      control.setAttribute('href', destination);
      return;
    }
    event.preventDefault();
    window.location.assign(destination);
  });

  document.addEventListener('justpress:set-change', function () { refresh(document); });
  document.addEventListener('justpress:state-change', function () { refresh(document); });
  document.addEventListener('shopify:section:load', function (event) { refresh(event.target || document); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { refresh(document); });
  else refresh(document);

  window.JPStartRoute = { refresh: refresh, destination: function (base) { return route(base); } };
})();
